export type EmojiIconCategory = {
    name        : string
    emojiIcons  : string[]
}

// Count of emoji "1849"

export const EMOJI_CATEGORIES: EmojiIconCategory[] = [
    {
        name: "Smileys",
        emojiIcons: [
            'emoji-1',
            'emoji-2',
            'emoji-3',
            'emoji-4',
            'emoji-5',
            'emoji-6',
            'emoji-7',
            'emoji-8',
            'emoji-9',
            'emoji-10',
            'emoji-11',
            'emoji-12',
            'emoji-13',
            'emoji-14',
            'emoji-15',
            'emoji-16',
            'emoji-17',
            'emoji-18',
            'emoji-19',
            'emoji-20',
            'emoji-21',
            'emoji-22',
            'emoji-23',
            'emoji-24',
            'emoji-25',
            'emoji-26',
            'emoji-27',
            'emoji-28',
            'emoji-29',
            'emoji-30',
            'emoji-31',
            'emoji-32',
            'emoji-33',
            'emoji-34',
            'emoji-35',
            'emoji-36',
            'emoji-37',
            'emoji-38',
            'emoji-39',
            'emoji-40',
            'emoji-41',
            'emoji-42',
            'emoji-43',
            'emoji-44',
            'emoji-45',
            'emoji-46',
            'emoji-47',
            'emoji-48',
            'emoji-49',
            'emoji-50',
            'emoji-51',
            'emoji-52',
            'emoji-53',
            'emoji-54',
            'emoji-55',
            'emoji-56',
            'emoji-57',
            'emoji-58',
            'emoji-59',
            'emoji-60',
            'emoji-61',
            'emoji-62',
            'emoji-63',
            'emoji-64',
            'emoji-65',
            'emoji-66',
            'emoji-67',
            'emoji-68',
            'emoji-69',
            'emoji-70',
            'emoji-71',
            'emoji-72',
            'emoji-73',
            'emoji-74',
            'emoji-75',
            'emoji-76',
            'emoji-77',
            'emoji-78',
            'emoji-79',
            'emoji-80',
            'emoji-81',
            'emoji-82',
            'emoji-83',
            'emoji-84',
            'emoji-85',
            'emoji-86',
            'emoji-87',
            'emoji-88',
            'emoji-89',
            'emoji-90',
            'emoji-91',
            'emoji-92',
            'emoji-93',
            'emoji-94',
            'emoji-95',
            'emoji-96',
            'emoji-97',
            'emoji-98',
            'emoji-99',
            'emoji-100',
            'emoji-101',
            'emoji-102',
            'emoji-103',
            'emoji-104',
            'emoji-105',
            'emoji-106',
            'emoji-107',
            'emoji-108',
            'emoji-109',
            'emoji-110',
            'emoji-111',
            'emoji-112',
            'emoji-113',
            'emoji-114',
            'emoji-115',
            'emoji-116',
            'emoji-117',
            'emoji-118',
            'emoji-119',
            'emoji-120',
            'emoji-121',
            'emoji-122',
            'emoji-123',
            'emoji-124',
            'emoji-125',
            'emoji-126',
            'emoji-127',
            'emoji-128',
            'emoji-129',
            'emoji-130',
            'emoji-131',
            'emoji-132',
            'emoji-133',
            'emoji-134',
            'emoji-135',
            'emoji-136',
            'emoji-137',
            'emoji-138',
            'emoji-139',
            'emoji-140',
            'emoji-141',
            'emoji-142',
            'emoji-143',
            'emoji-144',
            'emoji-145',
            'emoji-146',
            'emoji-147',
            'emoji-148',
            'emoji-149',
            'emoji-150',
            'emoji-151',
            'emoji-152',
            'emoji-153',
            'emoji-154',
            'emoji-155',
            'emoji-156',
            'emoji-157',
            'emoji-158',
            'emoji-159',
            'emoji-160',
            'emoji-161',
            'emoji-162',
            'emoji-163',
            'emoji-164',
            'emoji-165',
            'emoji-166',
            'emoji-167',
            'emoji-168',
            'emoji-169',
            'emoji-170',
            'emoji-171',
            'emoji-172',
            'emoji-173',
            'emoji-174',
            'emoji-175',
            'emoji-176',
            'emoji-177',
            'emoji-178',
            'emoji-179',
            'emoji-180',
            'emoji-181',
            'emoji-182',
            'emoji-183',
            'emoji-184',
            'emoji-185',
            'emoji-186',
            'emoji-187',
            'emoji-188',
            'emoji-189',
            'emoji-190',
            'emoji-191',
            'emoji-192',
            'emoji-193',
            'emoji-194',
            'emoji-195',
            'emoji-196',
            'emoji-197',
            'emoji-198',
            'emoji-199',
            'emoji-200',
            'emoji-201',
            'emoji-202',
            'emoji-203',
            'emoji-204',
            'emoji-205',
            'emoji-206',
            'emoji-207',
            'emoji-208',
            'emoji-209',
            'emoji-210',
            'emoji-211',
            'emoji-212',
            'emoji-213',
            'emoji-214',
            'emoji-215',
            'emoji-216',
            'emoji-217',
            'emoji-218',
            'emoji-219',
            'emoji-220',
            'emoji-221',
            'emoji-222',

        ]
    },
    {
        name: "People",
        emojiIcons: [
            'emoji-223',
            'emoji-224',
            'emoji-225',
            'emoji-226',
            'emoji-227',
            'emoji-228',
            'emoji-229',
            'emoji-230',
            'emoji-231',
            'emoji-232',
            'emoji-233',
            'emoji-234',
            'emoji-235',
            'emoji-236',
            'emoji-237',
            'emoji-238',
            'emoji-239',
            'emoji-240',
            'emoji-241',
            'emoji-242',
            'emoji-243',
            'emoji-244',
            'emoji-245',
            'emoji-246',
            'emoji-247',
            'emoji-248',
            'emoji-249',
            'emoji-250',
            'emoji-251',
            'emoji-252',
            'emoji-253',
            'emoji-254',
            'emoji-255',
            'emoji-256',
            'emoji-257',
            'emoji-258',
            'emoji-259',
            'emoji-260',
            'emoji-261',
            'emoji-262',
            'emoji-263',
            'emoji-264',
            'emoji-265',
            'emoji-266',
            'emoji-267',
            'emoji-268',
            'emoji-269',
            'emoji-270',
            'emoji-271',
            'emoji-272',
            'emoji-273',
            'emoji-274',
            'emoji-275',
            'emoji-276',
            'emoji-277',
            'emoji-278',
            'emoji-279',
            'emoji-280',
            'emoji-281',
            'emoji-282',
            'emoji-283',
            'emoji-284',
            'emoji-285',
            'emoji-286',
            'emoji-287',
            'emoji-288',
            'emoji-289',
            'emoji-290',
            'emoji-291',
            'emoji-292',
            'emoji-293',
            'emoji-294',
            'emoji-295',
            'emoji-296',
            'emoji-297',
            'emoji-298',
            'emoji-299',
            'emoji-300',
            'emoji-301',
            'emoji-302',
            'emoji-303',
            'emoji-304',
            'emoji-305',
            'emoji-306',
            'emoji-307',
            'emoji-308',
            'emoji-309',
            'emoji-310',
            'emoji-311',
            'emoji-312',
            'emoji-313',
            'emoji-314',
            'emoji-315',
            'emoji-316',
            'emoji-317',
            'emoji-318',
            'emoji-319',
            'emoji-320',
            'emoji-321',
            'emoji-322',
            'emoji-323',
            'emoji-324',
            'emoji-325',
            'emoji-326',
            'emoji-327',
            'emoji-328',
            'emoji-329',
            'emoji-330',
            'emoji-331',
            'emoji-332',
            'emoji-333',
            'emoji-334',
            'emoji-335',
            'emoji-336',
            'emoji-337',
            'emoji-338',
            'emoji-339',
            'emoji-340',
            'emoji-341',
            'emoji-342',
            'emoji-343',
            'emoji-344',
            'emoji-345',
            'emoji-346',
            'emoji-347',
            'emoji-348',
            'emoji-349',
            'emoji-350',
            'emoji-351',
            'emoji-352',
            'emoji-353',
            'emoji-354',
            'emoji-355',
            'emoji-356',
            'emoji-357',
            'emoji-358',
            'emoji-359',
            'emoji-360',
            'emoji-361',
            'emoji-362',
            'emoji-363',
            'emoji-364',
            'emoji-365',
            'emoji-366',
            'emoji-367',
            'emoji-368',
            'emoji-369',
            'emoji-370',
            'emoji-371',
            'emoji-372',
            'emoji-373',
            'emoji-374',
            'emoji-375',
            'emoji-376',
            'emoji-377',
            'emoji-378',
            'emoji-379',
            'emoji-380',
            'emoji-381',
            'emoji-382',
            'emoji-383',
            'emoji-384',
            'emoji-385',
            'emoji-386',
            'emoji-387',
            'emoji-388',
            'emoji-389',
            'emoji-390',
            'emoji-391',
            'emoji-392',
            'emoji-393',
            'emoji-394',
            'emoji-395',
            'emoji-396',
            'emoji-397',
            'emoji-398',
            'emoji-399',
            'emoji-400',
            'emoji-401',
            'emoji-402',
            'emoji-403',
            'emoji-404',
            'emoji-405',
            'emoji-406',
            'emoji-407',
            'emoji-408',
            'emoji-409',
            'emoji-410',
            'emoji-411',
            'emoji-412',
            'emoji-413',
            'emoji-414',
            'emoji-415',
            'emoji-416',
            'emoji-417',
            'emoji-418',
            'emoji-419',
            'emoji-420',
            'emoji-421',
            'emoji-422',
            'emoji-423',
            'emoji-424',
            'emoji-425',
            'emoji-426',
            'emoji-427',
            'emoji-428',
            'emoji-429',
            'emoji-430',
            'emoji-431',
            'emoji-432',
            'emoji-433',
            'emoji-434',
            'emoji-435',
            'emoji-436',
            'emoji-437',
            'emoji-438',
            'emoji-439',
            'emoji-440',
            'emoji-441',
            'emoji-442',
            'emoji-443',
            'emoji-444',
            'emoji-445',
            'emoji-446',
            'emoji-447',
            'emoji-448',
            'emoji-449',
            'emoji-450',
            'emoji-451',
            'emoji-452',
            'emoji-453',
            'emoji-454',
            'emoji-455',
            'emoji-456',
            'emoji-457',
            'emoji-458',
            'emoji-459',
            'emoji-460',
            'emoji-461',
            'emoji-462',
            'emoji-463',
            'emoji-464',
            'emoji-465',
            'emoji-466',
            'emoji-467',
            'emoji-468',
            'emoji-469',
            'emoji-470',
            'emoji-471',
            'emoji-472',
            'emoji-473',
            'emoji-474',
            'emoji-475',
            'emoji-476',
            'emoji-477',
            'emoji-478',
            'emoji-479',
            'emoji-480',
            'emoji-481',
            'emoji-482',
            'emoji-483',
            'emoji-484',
            'emoji-485',
            'emoji-486',
            'emoji-487',
            'emoji-488',
            'emoji-489',
            'emoji-490',
            'emoji-491',
            'emoji-492',
            'emoji-493',
            'emoji-494',
            'emoji-495',
            'emoji-496',
            'emoji-497',
            'emoji-498',
            'emoji-499',
            'emoji-500',
            'emoji-501',
            'emoji-502',
            'emoji-503',
            'emoji-504',
            'emoji-505',
            'emoji-506',
            'emoji-507',
            'emoji-508',
            'emoji-509',
            'emoji-510',
            'emoji-511',
            'emoji-512',
            'emoji-513',
            'emoji-514',
            'emoji-515',
            'emoji-516',
            'emoji-517',
            'emoji-518',
            'emoji-519',
            'emoji-520',
            'emoji-521',
            'emoji-522',
            'emoji-523',
            'emoji-524',
        ]
    },
    {
        name: "Animals and nature",
        emojiIcons: [
            'emoji-525',
            'emoji-526',
            'emoji-527',
            'emoji-528',
            'emoji-529',
            'emoji-530',
            'emoji-531',
            'emoji-532',
            'emoji-533',
            'emoji-534',
            'emoji-535',
            'emoji-536',
            'emoji-537',
            'emoji-538',
            'emoji-539',
            'emoji-540',
            'emoji-541',
            'emoji-542',
            'emoji-543',
            'emoji-544',
            'emoji-545',
            'emoji-546',
            'emoji-547',
            'emoji-548',
            'emoji-549',
            'emoji-550',
            'emoji-551',
            'emoji-552',
            'emoji-553',
            'emoji-554',
            'emoji-555',
            'emoji-556',
            'emoji-557',
            'emoji-558',
            'emoji-559',
            'emoji-560',
            'emoji-561',
            'emoji-562',
            'emoji-563',
            'emoji-564',
            'emoji-565',
            'emoji-566',
            'emoji-567',
            'emoji-568',
            'emoji-569',
            'emoji-570',
            'emoji-571',
            'emoji-572',
            'emoji-573',
            'emoji-574',
            'emoji-575',
            'emoji-576',
            'emoji-577',
            'emoji-578',
            'emoji-579',
            'emoji-580',
            'emoji-581',
            'emoji-582',
            'emoji-583',
            'emoji-584',
            'emoji-585',
            'emoji-586',
            'emoji-587',
            'emoji-588',
            'emoji-589',
            'emoji-590',
            'emoji-591',
            'emoji-592',
            'emoji-593',
            'emoji-594',
            'emoji-595',
            'emoji-596',
            'emoji-597',
            'emoji-598',
            'emoji-599',
            'emoji-600',
            'emoji-601',
            'emoji-602',
            'emoji-603',
            'emoji-604',
            'emoji-605',
            'emoji-606',
            'emoji-607',
            'emoji-608',
            'emoji-609',
            'emoji-610',
            'emoji-611',
            'emoji-612',
            'emoji-613',
            'emoji-614',
            'emoji-615',
            'emoji-616',
            'emoji-617',
            'emoji-618',
            'emoji-619',
            'emoji-620',
            'emoji-621',
            'emoji-622',
            'emoji-623',
            'emoji-624',
            'emoji-625',
            'emoji-626',
            'emoji-627',
            'emoji-628',
            'emoji-629',
            'emoji-630',
            'emoji-631',
            'emoji-632',
            'emoji-633',
            'emoji-634',
            'emoji-635',
            'emoji-636',
            'emoji-637',
            'emoji-638',
            'emoji-639',
            'emoji-640',
            'emoji-641',
            'emoji-642',
            'emoji-643',
            'emoji-644',
            'emoji-645',
            'emoji-646',
            'emoji-647',
            'emoji-648',
            'emoji-649',
            'emoji-650',
            'emoji-651',
            'emoji-652',
            'emoji-653',
            'emoji-654',
            'emoji-655',
            'emoji-656',
            'emoji-657',
            'emoji-658',
            'emoji-659',
            'emoji-660',
            'emoji-661',
            'emoji-662',
            'emoji-663',
            'emoji-664',
            'emoji-665',
            'emoji-666',
            'emoji-667',
            'emoji-668',
        ]
    },
    {
        name: "Food and drink",
        emojiIcons: [
            'emoji-669',
            'emoji-670',
            'emoji-671',
            'emoji-672',
            'emoji-673',
            'emoji-674',
            'emoji-675',
            'emoji-676',
            'emoji-677',
            'emoji-678',
            'emoji-679',
            'emoji-680',
            'emoji-681',
            'emoji-682',
            'emoji-683',
            'emoji-684',
            'emoji-685',
            'emoji-686',
            'emoji-687',
            'emoji-688',
            'emoji-689',
            'emoji-690',
            'emoji-691',
            'emoji-692',
            'emoji-693',
            'emoji-694',
            'emoji-695',
            'emoji-696',
            'emoji-697',
            'emoji-698',
            'emoji-699',
            'emoji-700',
            'emoji-701',
            'emoji-702',
            'emoji-703',
            'emoji-704',
            'emoji-705',
            'emoji-706',
            'emoji-707',
            'emoji-708',
            'emoji-709',
            'emoji-710',
            'emoji-711',
            'emoji-712',
            'emoji-713',
            'emoji-714',
            'emoji-715',
            'emoji-716',
            'emoji-717',
            'emoji-718',
            'emoji-719',
            'emoji-720',
            'emoji-721',
            'emoji-722',
            'emoji-723',
            'emoji-724',
            'emoji-725',
            'emoji-726',
            'emoji-727',
            'emoji-728',
            'emoji-729',
            'emoji-730',
            'emoji-731',
            'emoji-732',
            'emoji-733',
            'emoji-734',
            'emoji-735',
            'emoji-736',
            'emoji-737',
            'emoji-738',
            'emoji-739',
            'emoji-740',
            'emoji-741',
            'emoji-742',
            'emoji-743',
            'emoji-744',
            'emoji-745',
            'emoji-746',
            'emoji-747',
            'emoji-748',
            'emoji-749',
            'emoji-750',
            'emoji-751',
            'emoji-752',
            'emoji-753',
            'emoji-754',
            'emoji-755',
            'emoji-756',
            'emoji-757',
            'emoji-758',
            'emoji-759',
            'emoji-760',
            'emoji-761',
            'emoji-762',
            'emoji-763',
            'emoji-764',
            'emoji-765',
            'emoji-766',
            'emoji-767',
            'emoji-768',
            'emoji-769',
            'emoji-770',
            'emoji-771',
            'emoji-772',
            'emoji-773',
            'emoji-774',
            'emoji-775',
            'emoji-776',
            'emoji-777',
            'emoji-778',
            'emoji-779',
            'emoji-780',
            'emoji-781',
            'emoji-782',
            'emoji-783',
            'emoji-784',
            'emoji-785',
            'emoji-786',
            'emoji-787',
            'emoji-788',
            'emoji-789',
            'emoji-790',
            'emoji-791',
            'emoji-792',
            'emoji-793',
            'emoji-794',
            'emoji-795',
            'emoji-796',
            'emoji-797',
            'emoji-798',
            'emoji-799',
            'emoji-800',
        ]
    },
    {
        name: "Travel and places",
        emojiIcons: [
            'emoji-801',
            'emoji-802',
            'emoji-803',
            'emoji-804',
            'emoji-805',
            'emoji-806',
            'emoji-807',
            'emoji-808',
            'emoji-809',
            'emoji-810',
            'emoji-811',
            'emoji-812',
            'emoji-813',
            'emoji-814',
            'emoji-815',
            'emoji-816',
            'emoji-817',
            'emoji-818',
            'emoji-819',
            'emoji-820',
            'emoji-821',
            'emoji-822',
            'emoji-823',
            'emoji-824',
            'emoji-825',
            'emoji-826',
            'emoji-827',
            'emoji-828',
            'emoji-829',
            'emoji-830',
            'emoji-831',
            'emoji-832',
            'emoji-833',
            'emoji-834',
            'emoji-835',
            'emoji-836',
            'emoji-837',
            'emoji-838',
            'emoji-839',
            'emoji-840',
            'emoji-841',
            'emoji-842',
            'emoji-843',
            'emoji-844',
            'emoji-845',
            'emoji-846',
            'emoji-847',
            'emoji-848',
            'emoji-849',
            'emoji-850',
            'emoji-851',
            'emoji-852',
            'emoji-853',
            'emoji-854',
            'emoji-855',
            'emoji-856',
            'emoji-857',
            'emoji-858',
            'emoji-859',
            'emoji-860',
            'emoji-861',
            'emoji-862',
            'emoji-863',
            'emoji-864',
            'emoji-865',
            'emoji-866',
            'emoji-867',
            'emoji-868',
            'emoji-869',
            'emoji-870',
            'emoji-871',
            'emoji-872',
            'emoji-873',
            'emoji-874',
            'emoji-875',
            'emoji-876',
            'emoji-877',
            'emoji-878',
            'emoji-879',
            'emoji-880',
            'emoji-881',
            'emoji-882',
            'emoji-883',
            'emoji-884',
            'emoji-885',
            'emoji-886',
            'emoji-887',
            'emoji-888',
            'emoji-889',
            'emoji-890',
            'emoji-891',
            'emoji-892',
            'emoji-893',
            'emoji-894',
            'emoji-895',
            'emoji-896',
            'emoji-897',
            'emoji-898',
            'emoji-899',
            'emoji-900',
            'emoji-901',
            'emoji-902',
            'emoji-903',
            'emoji-904',
            'emoji-905',
            'emoji-906',
            'emoji-907',
            'emoji-908',
            'emoji-909',
            'emoji-910',
            'emoji-911',
            'emoji-912',
            'emoji-913',
            'emoji-914',
            'emoji-915',
            'emoji-916',
            'emoji-917',
            'emoji-918',
            'emoji-919',
            'emoji-920',
            'emoji-921',
            'emoji-922',
            'emoji-923',
            'emoji-924',
            'emoji-925',
            'emoji-926',
            'emoji-927',
            'emoji-928',
            'emoji-929',
            'emoji-930',
            'emoji-931',
            'emoji-932',
            'emoji-933',
            'emoji-934',
            'emoji-935',
            'emoji-936',
            'emoji-937',
            'emoji-938',
            'emoji-939',
            'emoji-940',
            'emoji-941',
            'emoji-942',
            'emoji-943',
            'emoji-944',
            'emoji-945',
            'emoji-946',
            'emoji-947',
            'emoji-948',
            'emoji-949',
            'emoji-950',
            'emoji-951',
            'emoji-952',
            'emoji-953',
            'emoji-954',
            'emoji-955',
            'emoji-956',
            'emoji-957',
            'emoji-958',
            'emoji-959',
            'emoji-960',
            'emoji-961',
            'emoji-962',
            'emoji-963',
            'emoji-964',
            'emoji-965',
            'emoji-966',
            'emoji-967',
            'emoji-968',
            'emoji-969',
            'emoji-970',
            'emoji-971',
            'emoji-972',
            'emoji-973',
            'emoji-974',
            'emoji-975',
            'emoji-976',
            'emoji-977',
            'emoji-978',
            'emoji-979',
            'emoji-980',
            'emoji-981',
            'emoji-982',
            'emoji-983',
            'emoji-984',
            'emoji-985',
            'emoji-986',
            'emoji-987',
            'emoji-988',
            'emoji-989',
            'emoji-990',
            'emoji-991',
            'emoji-992',
            'emoji-993',
            'emoji-994',
            'emoji-995',
            'emoji-996',
            'emoji-997',
            'emoji-998',
            'emoji-999',
            'emoji-1000',
            'emoji-1001',
            'emoji-1002',
            'emoji-1003',
            'emoji-1004',
            'emoji-1005',
            'emoji-1006',
            'emoji-1007',
            'emoji-1008',
            'emoji-1009',
            'emoji-1010',
            'emoji-1011',
            'emoji-1012',
            'emoji-1013',
            'emoji-1014',
            'emoji-1015',
            'emoji-1016',
            'emoji-1017',
            'emoji-1018',
        ]
    },
    {
        name: "Activities",
        emojiIcons: [
            'emoji-1019',
            'emoji-1020',
            'emoji-1021',
            'emoji-1022',
            'emoji-1023',
            'emoji-1024',
            'emoji-1025',
            'emoji-1026',
            'emoji-1027',
            'emoji-1028',
            'emoji-1029',
            'emoji-1030',
            'emoji-1031',
            'emoji-1032',
            'emoji-1033',
            'emoji-1034',
            'emoji-1035',
            'emoji-1036',
            'emoji-1037',
            'emoji-1038',
            'emoji-1039',
            'emoji-1040',
            'emoji-1041',
            'emoji-1042',
            'emoji-1043',
            'emoji-1044',
            'emoji-1045',
            'emoji-1046',
            'emoji-1047',
            'emoji-1048',
            'emoji-1049',
            'emoji-1050',
            'emoji-1051',
            'emoji-1052',
            'emoji-1053',
            'emoji-1054',
            'emoji-1055',
            'emoji-1056',
            'emoji-1057',
            'emoji-1058',
            'emoji-1059',
            'emoji-1060',
            'emoji-1061',
            'emoji-1062',
            'emoji-1063',
            'emoji-1064',
            'emoji-1065',
            'emoji-1066',
            'emoji-1067',
            'emoji-1068',
            'emoji-1069',
            'emoji-1070',
            'emoji-1071',
            'emoji-1072',
            'emoji-1073',
            'emoji-1074',
            'emoji-1075',
            'emoji-1076',
            'emoji-1077',
            'emoji-1078',
            'emoji-1079',
            'emoji-1080',
            'emoji-1081',
            'emoji-1082',
            'emoji-1083',
            'emoji-1084',
            'emoji-1085',
            'emoji-1086',
            'emoji-1087',
            'emoji-1088',
            'emoji-1089',
            'emoji-1090',
            'emoji-1091',
            'emoji-1092',
            'emoji-1093',
            'emoji-1094',
            'emoji-1095',
            'emoji-1096',
            'emoji-1097',
            'emoji-1098',
            'emoji-1099',
            'emoji-1100',
            'emoji-1101',
            'emoji-1102',
            'emoji-1103',
            'emoji-1104',
        ]
    },
    {
        name: "Objects",
        emojiIcons: [
            'emoji-1105',
            'emoji-1106',
            'emoji-1107',
            'emoji-1108',
            'emoji-1109',
            'emoji-1110',
            'emoji-1111',
            'emoji-1112',
            'emoji-1113',
            'emoji-1114',
            'emoji-1115',
            'emoji-1116',
            'emoji-1117',
            'emoji-1118',
            'emoji-1119',
            'emoji-1120',
            'emoji-1121',
            'emoji-1122',
            'emoji-1123',
            'emoji-1124',
            'emoji-1125',
            'emoji-1126',
            'emoji-1127',
            'emoji-1128',
            'emoji-1129',
            'emoji-1130',
            'emoji-1131',
            'emoji-1132',
            'emoji-1133',
            'emoji-1134',
            'emoji-1135',
            'emoji-1136',
            'emoji-1137',
            'emoji-1138',
            'emoji-1139',
            'emoji-1140',
            'emoji-1141',
            'emoji-1142',
            'emoji-1143',
            'emoji-1144',
            'emoji-1145',
            'emoji-1146',
            'emoji-1147',
            'emoji-1148',
            'emoji-1149',
            'emoji-1150',
            'emoji-1151',
            'emoji-1152',
            'emoji-1153',
            'emoji-1154',
            'emoji-1155',
            'emoji-1156',
            'emoji-1157',
            'emoji-1158',
            'emoji-1159',
            'emoji-1160',
            'emoji-1161',
            'emoji-1162',
            'emoji-1163',
            'emoji-1164',
            'emoji-1165',
            'emoji-1166',
            'emoji-1167',
            'emoji-1168',
            'emoji-1169',
            'emoji-1170',
            'emoji-1171',
            'emoji-1172',
            'emoji-1173',
            'emoji-1174',
            'emoji-1175',
            'emoji-1176',
            'emoji-1177',
            'emoji-1178',
            'emoji-1179',
            'emoji-1180',
            'emoji-1181',
            'emoji-1182',
            'emoji-1183',
            'emoji-1184',
            'emoji-1185',
            'emoji-1186',
            'emoji-1187',
            'emoji-1188',
            'emoji-1189',
            'emoji-1190',
            'emoji-1191',
            'emoji-1192',
            'emoji-1193',
            'emoji-1194',
            'emoji-1195',
            'emoji-1196',
            'emoji-1197',
            'emoji-1198',
            'emoji-1199',
            'emoji-1200',
            'emoji-1201',
            'emoji-1202',
            'emoji-1203',
            'emoji-1204',
            'emoji-1205',
            'emoji-1206',
            'emoji-1207',
            'emoji-1208',
            'emoji-1209',
            'emoji-1210',
            'emoji-1211',
            'emoji-1212',
            'emoji-1213',
            'emoji-1214',
            'emoji-1215',
            'emoji-1216',
            'emoji-1217',
            'emoji-1218',
            'emoji-1219',
            'emoji-1220',
            'emoji-1221',
            'emoji-1222',
            'emoji-1223',
            'emoji-1224',
            'emoji-1225',
            'emoji-1226',
            'emoji-1227',
            'emoji-1228',
            'emoji-1229',
            'emoji-1230',
            'emoji-1231',
            'emoji-1232',
            'emoji-1233',
            'emoji-1234',
            'emoji-1235',
            'emoji-1236',
            'emoji-1237',
            'emoji-1238',
            'emoji-1239',
            'emoji-1240',
            'emoji-1241',
            'emoji-1242',
            'emoji-1243',
            'emoji-1244',
            'emoji-1245',
            'emoji-1246',
            'emoji-1247',
            'emoji-1248',
            'emoji-1249',
            'emoji-1250',
            'emoji-1251',
            'emoji-1252',
            'emoji-1253',
            'emoji-1254',
            'emoji-1255',
            'emoji-1256',
            'emoji-1257',
            'emoji-1258',
            'emoji-1259',
            'emoji-1260',
            'emoji-1261',
            'emoji-1262',
            'emoji-1263',
            'emoji-1264',
            'emoji-1265',
            'emoji-1266',
            'emoji-1267',
            'emoji-1268',
            'emoji-1269',
            'emoji-1270',
            'emoji-1271',
            'emoji-1272',
            'emoji-1273',
            'emoji-1274',
            'emoji-1275',
            'emoji-1276',
            'emoji-1277',
            'emoji-1278',
            'emoji-1279',
            'emoji-1280',
            'emoji-1281',
            'emoji-1282',
            'emoji-1283',
            'emoji-1284',
            'emoji-1285',
            'emoji-1286',
            'emoji-1287',
            'emoji-1288',
            'emoji-1289',
            'emoji-1290',
            'emoji-1291',
            'emoji-1292',
            'emoji-1293',
            'emoji-1294',
            'emoji-1295',
            'emoji-1296',
            'emoji-1297',
            'emoji-1298',
            'emoji-1299',
            'emoji-1300',
            'emoji-1301',
            'emoji-1302',
            'emoji-1303',
            'emoji-1304',
            'emoji-1305',
            'emoji-1306',
            'emoji-1307',
            'emoji-1308',
            'emoji-1309',
            'emoji-1310',
            'emoji-1311',
            'emoji-1312',
            'emoji-1313',
            'emoji-1314',
            'emoji-1315',
            'emoji-1316',
            'emoji-1317',
            'emoji-1318',
            'emoji-1319',
            'emoji-1320',
            'emoji-1321',
            'emoji-1322',
            'emoji-1323',
            'emoji-1324',
            'emoji-1325',
            'emoji-1326',
            'emoji-1327',
            'emoji-1328',
            'emoji-1329',
            'emoji-1330',
            'emoji-1331',
            'emoji-1332',
            'emoji-1333',
            'emoji-1334',
            'emoji-1335',
            'emoji-1336',
            'emoji-1337',
            'emoji-1338',
            'emoji-1339',
            'emoji-1340',
            'emoji-1341',
            'emoji-1342',
            'emoji-1343',
            'emoji-1344',
            'emoji-1345',
            'emoji-1346',
            'emoji-1347',
            'emoji-1348',
            'emoji-1349',
            'emoji-1350',
            'emoji-1351',
            'emoji-1352',
            'emoji-1353',
            'emoji-1354',
            'emoji-1355',
            'emoji-1356',
            'emoji-1357',
            'emoji-1358',
            'emoji-1359',
        ]
    },
    {
        name: 'Symbols',
        emojiIcons: [
            'emoji-1360',
            'emoji-1361',
            'emoji-1362',
            'emoji-1363',
            'emoji-1364',
            'emoji-1365',
            'emoji-1366',
            'emoji-1367',
            'emoji-1368',
            'emoji-1369',
            'emoji-1370',
            'emoji-1371',
            'emoji-1372',
            'emoji-1373',
            'emoji-1374',
            'emoji-1375',
            'emoji-1376',
            'emoji-1377',
            'emoji-1378',
            'emoji-1379',
            'emoji-1380',
            'emoji-1381',
            'emoji-1382',
            'emoji-1383',
            'emoji-1384',
            'emoji-1385',
            'emoji-1386',
            'emoji-1387',
            'emoji-1388',
            'emoji-1389',
            'emoji-1390',
            'emoji-1391',
            'emoji-1392',
            'emoji-1393',
            'emoji-1394',
            'emoji-1395',
            'emoji-1396',
            'emoji-1397',
            'emoji-1398',
            'emoji-1399',
            'emoji-1400',
            'emoji-1401',
            'emoji-1402',
            'emoji-1403',
            'emoji-1404',
            'emoji-1405',
            'emoji-1406',
            'emoji-1407',
            'emoji-1408',
            'emoji-1409',
            'emoji-1410',
            'emoji-1411',
            'emoji-1412',
            'emoji-1413',
            'emoji-1414',
            'emoji-1415',
            'emoji-1416',
            'emoji-1417',
            'emoji-1418',
            'emoji-1419',
            'emoji-1420',
            'emoji-1421',
            'emoji-1422',
            'emoji-1423',
            'emoji-1424',
            'emoji-1425',
            'emoji-1426',
            'emoji-1427',
            'emoji-1428',
            'emoji-1429',
            'emoji-1430',
            'emoji-1431',
            'emoji-1432',
            'emoji-1433',
            'emoji-1434',
            'emoji-1435',
            'emoji-1436',
            'emoji-1437',
            'emoji-1438',
            'emoji-1439',
            'emoji-1440',
            'emoji-1441',
            'emoji-1442',
            'emoji-1443',
            'emoji-1444',
            'emoji-1445',
            'emoji-1446',
            'emoji-1447',
            'emoji-1448',
            'emoji-1449',
            'emoji-1450',
            'emoji-1451',
            'emoji-1452',
            'emoji-1453',
            'emoji-1454',
            'emoji-1455',
            'emoji-1456',
            'emoji-1457',
            'emoji-1458',
            'emoji-1459',
            'emoji-1460',
            'emoji-1461',
            'emoji-1462',
            'emoji-1463',
            'emoji-1464',
            'emoji-1465',
            'emoji-1466',
            'emoji-1467',
            'emoji-1468',
            'emoji-1469',
            'emoji-1470',
            'emoji-1471',
            'emoji-1472',
            'emoji-1473',
            'emoji-1474',
            'emoji-1475',
            'emoji-1476',
            'emoji-1477',
            'emoji-1478',
            'emoji-1479',
            'emoji-1480',
            'emoji-1481',
            'emoji-1482',
            'emoji-1483',
            'emoji-1484',
            'emoji-1485',
            'emoji-1486',
            'emoji-1487',
            'emoji-1488',
            'emoji-1489',
            'emoji-1490',
            'emoji-1491',
            'emoji-1492',
            'emoji-1493',
            'emoji-1494',
            'emoji-1495',
            'emoji-1496',
            'emoji-1497',
            'emoji-1498',
            'emoji-1499',
            'emoji-1500',
            'emoji-1501',
            'emoji-1502',
            'emoji-1503',
            'emoji-1504',
            'emoji-1505',
            'emoji-1506',
            'emoji-1507',
            'emoji-1508',
            'emoji-1509',
            'emoji-1510',
            'emoji-1511',
            'emoji-1512',
            'emoji-1513',
            'emoji-1514',
            'emoji-1515',
            'emoji-1516',
            'emoji-1517',
            'emoji-1518',
            'emoji-1519',
            'emoji-1520',
            'emoji-1521',
            'emoji-1522',
            'emoji-1523',
            'emoji-1524',
            'emoji-1525',
            'emoji-1526',
            'emoji-1527',
            'emoji-1528',
            'emoji-1529',
            'emoji-1530',
            'emoji-1531',
            'emoji-1532',
            'emoji-1533',
            'emoji-1534',
            'emoji-1535',
            'emoji-1536',
            'emoji-1537',
            'emoji-1538',
            'emoji-1539',
            'emoji-1540',
            'emoji-1541',
            'emoji-1542',
            'emoji-1543',
            'emoji-1544',
            'emoji-1545',
            'emoji-1546',
            'emoji-1547',
            'emoji-1548',
            'emoji-1549',
            'emoji-1550',
            'emoji-1551',
            'emoji-1552',
            'emoji-1553',
            'emoji-1554',
            'emoji-1555',
            'emoji-1556',
            'emoji-1557',
            'emoji-1558',
            'emoji-1559',
            'emoji-1560',
            'emoji-1561',
            'emoji-1562',
            'emoji-1563',
            'emoji-1564',
            'emoji-1565',
            'emoji-1566',
            'emoji-1567',
            'emoji-1568',
            'emoji-1569',
            'emoji-1570',
            'emoji-1571',
            'emoji-1572',
            'emoji-1573',
            'emoji-1574',
            'emoji-1575',
            'emoji-1576',
            'emoji-1577',
            'emoji-1578',
            'emoji-1579',
            'emoji-1580',
        ]
    },
    {
        name: 'Flags',
        emojiIcons: [
            'emoji-1581',
            'emoji-1582',
            'emoji-1583',
            'emoji-1584',
            'emoji-1585',
            'emoji-1586',
            'emoji-1587',
            'emoji-1588',
            'emoji-1589',
            'emoji-1590',
            'emoji-1591',
            'emoji-1592',
            'emoji-1593',
            'emoji-1594',
            'emoji-1595',
            'emoji-1596',
            'emoji-1597',
            'emoji-1598',
            'emoji-1599',
            'emoji-1600',
            'emoji-1601',
            'emoji-1602',
            'emoji-1603',
            'emoji-1604',
            'emoji-1605',
            'emoji-1606',
            'emoji-1607',
            'emoji-1608',
            'emoji-1609',
            'emoji-1610',
            'emoji-1611',
            'emoji-1612',
            'emoji-1613',
            'emoji-1614',
            'emoji-1615',
            'emoji-1616',
            'emoji-1617',
            'emoji-1618',
            'emoji-1619',
            'emoji-1620',
            'emoji-1621',
            'emoji-1622',
            'emoji-1623',
            'emoji-1624',
            'emoji-1625',
            'emoji-1626',
            'emoji-1627',
            'emoji-1628',
            'emoji-1629',
            'emoji-1630',
            'emoji-1631',
            'emoji-1632',
            'emoji-1633',
            'emoji-1634',
            'emoji-1635',
            'emoji-1636',
            'emoji-1637',
            'emoji-1638',
            'emoji-1639',
            'emoji-1640',
            'emoji-1641',
            'emoji-1642',
            'emoji-1643',
            'emoji-1644',
            'emoji-1645',
            'emoji-1646',
            'emoji-1647',
            'emoji-1648',
            'emoji-1649',
            'emoji-1650',
            'emoji-1651',
            'emoji-1652',
            'emoji-1653',
            'emoji-1654',
            'emoji-1655',
            'emoji-1656',
            'emoji-1657',
            'emoji-1658',
            'emoji-1659',
            'emoji-1660',
            'emoji-1661',
            'emoji-1662',
            'emoji-1663',
            'emoji-1664',
            'emoji-1665',
            'emoji-1666',
            'emoji-1667',
            'emoji-1668',
            'emoji-1669',
            'emoji-1670',
            'emoji-1671',
            'emoji-1672',
            'emoji-1673',
            'emoji-1674',
            'emoji-1675',
            'emoji-1676',
            'emoji-1677',
            'emoji-1678',
            'emoji-1679',
            'emoji-1680',
            'emoji-1681',
            'emoji-1682',
            'emoji-1683',
            'emoji-1684',
            'emoji-1685',
            'emoji-1686',
            'emoji-1687',
            'emoji-1688',
            'emoji-1689',
            'emoji-1690',
            'emoji-1691',
            'emoji-1692',
            'emoji-1693',
            'emoji-1694',
            'emoji-1695',
            'emoji-1696',
            'emoji-1697',
            'emoji-1698',
            'emoji-1699',
            'emoji-1700',
            'emoji-1701',
            'emoji-1702',
            'emoji-1703',
            'emoji-1704',
            'emoji-1705',
            'emoji-1706',
            'emoji-1707',
            'emoji-1708',
            'emoji-1709',
            'emoji-1710',
            'emoji-1711',
            'emoji-1712',
            'emoji-1713',
            'emoji-1714',
            'emoji-1715',
            'emoji-1716',
            'emoji-1717',
            'emoji-1718',
            'emoji-1719',
            'emoji-1720',
            'emoji-1721',
            'emoji-1722',
            'emoji-1723',
            'emoji-1724',
            'emoji-1725',
            'emoji-1726',
            'emoji-1727',
            'emoji-1728',
            'emoji-1729',
            'emoji-1730',
            'emoji-1731',
            'emoji-1732',
            'emoji-1733',
            'emoji-1734',
            'emoji-1735',
            'emoji-1736',
            'emoji-1737',
            'emoji-1738',
            'emoji-1739',
            'emoji-1740',
            'emoji-1741',
            'emoji-1742',
            'emoji-1743',
            'emoji-1744',
            'emoji-1745',
            'emoji-1746',
            'emoji-1747',
            'emoji-1748',
            'emoji-1749',
            'emoji-1750',
            'emoji-1751',
            'emoji-1752',
            'emoji-1753',
            'emoji-1754',
            'emoji-1755',
            'emoji-1756',
            'emoji-1757',
            'emoji-1758',
            'emoji-1759',
            'emoji-1760',
            'emoji-1761',
            'emoji-1762',
            'emoji-1763',
            'emoji-1764',
            'emoji-1765',
            'emoji-1766',
            'emoji-1767',
            'emoji-1768',
            'emoji-1769',
            'emoji-1770',
            'emoji-1771',
            'emoji-1772',
            'emoji-1773',
            'emoji-1774',
            'emoji-1775',
            'emoji-1776',
            'emoji-1777',
            'emoji-1778',
            'emoji-1779',
            'emoji-1780',
            'emoji-1781',
            'emoji-1782',
            'emoji-1783',
            'emoji-1784',
            'emoji-1785',
            'emoji-1786',
            'emoji-1787',
            'emoji-1788',
            'emoji-1789',
            'emoji-1790',
            'emoji-1791',
            'emoji-1792',
            'emoji-1793',
            'emoji-1794',
            'emoji-1795',
            'emoji-1796',
            'emoji-1797',
            'emoji-1798',
            'emoji-1799',
            'emoji-1800',
            'emoji-1801',
            'emoji-1802',
            'emoji-1803',
            'emoji-1804',
            'emoji-1805',
            'emoji-1806',
            'emoji-1807',
            'emoji-1808',
            'emoji-1809',
            'emoji-1810',
            'emoji-1811',
            'emoji-1812',
            'emoji-1813',
            'emoji-1814',
            'emoji-1815',
            'emoji-1816',
            'emoji-1817',
            'emoji-1818',
            'emoji-1819',
            'emoji-1820',
            'emoji-1821',
            'emoji-1822',
            'emoji-1823',
            'emoji-1824',
            'emoji-1825',
            'emoji-1826',
            'emoji-1827',
            'emoji-1828',
            'emoji-1829',
            'emoji-1830',
            'emoji-1831',
            'emoji-1832',
            'emoji-1833',
            'emoji-1834',
            'emoji-1835',
            'emoji-1836',
            'emoji-1837',
            'emoji-1838',
            'emoji-1839',
            'emoji-1840',
            'emoji-1841',
            'emoji-1842',
            'emoji-1843',
            'emoji-1844',
            'emoji-1845',
            'emoji-1846',
            'emoji-1847',
            'emoji-1848',
            'emoji-1849'
        ]
    }
]
